import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { isAdmin, isSupervisor, hasSubscriptionFeature } from "utils/utils";
import { useLocation } from "react-router-dom";
import UpgradeModal from "components/Modal/UpgradeModal";
import { useTranslation } from "react-i18next";

const PlanNavigationTabs = ({ children }) => {
	const { t } = useTranslation();
	const location = useLocation();
	const canSupervise = isAdmin() || isSupervisor();
	const [showUpgradeModal, setShowUpgradeModal] = useState(false);
	const [upgradeFeature, setUpgradeFeature] = useState("");
	const hasForecastingSubscription = hasSubscriptionFeature("FORECASTING");

	const handleActiveClick = (e, isActive) => {
		if (isActive) {
			e.preventDefault();
		}
	};

	return (
		<>
			<div className="navigation-tabs-container">
				<Nav variant="tabs" className="navigation-tabs">
					<Nav.Item>
						<NavLink
							to="/plans"
							className="nav-link"
							activeClassName="active disabled-link"
							onClick={(e) =>
								handleActiveClick(e, location.pathname === "/plans")
							}
						>
							{t("plans.title")}
						</NavLink>
					</Nav.Item>
					{!canSupervise && (
						<Nav.Item>
							<NavLink
								to="/my-preferences"
								className="nav-link"
								activeClassName="active disabled-link"
								onClick={(e) =>
									handleActiveClick(e, location.pathname === "/my-preferences")
								}
							>
								{t("preferences.myTitle")}
							</NavLink>
						</Nav.Item>
					)}

					{canSupervise && (
						<>
							<Nav.Item>
								<NavLink
									to="/pending-preferences"
									className="nav-link"
									activeClassName="active disabled-link"
									onClick={(e) =>
										handleActiveClick(
											e,
											location.pathname === "/pending-preferences"
										)
									}
								>
									{t("preferences.approveTab")}
								</NavLink>
							</Nav.Item>
							<Nav.Item>
								<NavLink
									to="/managed-preferences"
									className="nav-link"
									activeClassName="active disabled-link"
									onClick={(e) =>
										handleActiveClick(
											e,
											location.pathname === "/managed-preferences"
										)
									}
								>
									{t("preferences.managedTab")}
								</NavLink>
							</Nav.Item>
						</>
					)}

					{isAdmin() && (
						<Nav.Item>
							{hasForecastingSubscription ? (
								<NavLink
									to="/forecasting"
									className="nav-link"
									activeClassName="active disabled-link"
									onClick={(e) =>
										handleActiveClick(e, location.pathname === "/forecasting")
									}
								>
									Forecasting
								</NavLink>
							) : (
								<div
									className="nav-link disabled-subscription"
									onClick={(e) => {
										e.preventDefault();
										setShowUpgradeModal(true);
										setUpgradeFeature("Forecasting");
									}}
									style={{
										opacity: 0.5,
										cursor: "not-allowed",
										position: "relative",
									}}
								>
									Forecasting
								</div>
							)}
						</Nav.Item>
					)}
				</Nav>
				{children && <div className="tabs-actions">{children}</div>}
			</div>

			<UpgradeModal
				show={showUpgradeModal}
				onClose={() => setShowUpgradeModal(false)}
				feature={upgradeFeature}
				requiredPlan="Pro"
			/>
		</>
	);
};

export default PlanNavigationTabs;
